import { useState } from "react";

export default function useBoolean(
    defaultValue: boolean = false
): [boolean, () => void, () => void] {
    const [value, setValue] = useState(defaultValue);
    function setTrue() {
        setValue(true);
    }

    function setFalse() {
        setValue(false);
    }

    return [value, setTrue, setFalse];
}
